import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import styles from './DashboardCard.module.scss'

interface Props {
  title: string;
  value: number; // Adjust type as per your data type
  icon: IconDefinition; // Adjust if using FontAwesome icons
  link?: string; // Optional link
}

const DashboardCard: React.FC<Props> = ({ title, value, icon, link }) => {
	return (
		<Col md={4} xs={12}>
			<Card className={styles.overviewCard}>
				<Card.Body>
					{link ? (
						<Link to={link}>
							<Row>
								<Col xs={4} className={styles.svgImgWrapper}>
									<FontAwesomeIcon icon={icon} />
								</Col>
								<Col>
									<div>
										<h2>{value}</h2>
										<small>{title}</small>
									</div>
								</Col>
							</Row>
						</Link>
					) : (
						<Row>
							<Col xs={4} className={styles.svgImgWrapper}>
								<FontAwesomeIcon icon={icon} />
							</Col>
							<Col>
								<div>
									<h2>{value}</h2>
									<small>{title}</small>
								</div>
							</Col>
						</Row>
					)}
				</Card.Body>
			</Card>
		</Col>
	)
}

export default DashboardCard
